import React from "react"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

import infoCircleIcon from "@front-shared/assets/images/icons/info-circle.svg"

export const PayerMappingsInfoNoticeComponent: React.FunctionComponent<
    IPayerMappingsInfoNoticeComponentProps
> = props => {
    return (
        <div
            className={`
                flex items-start gap-[8px] rounded-[8px]
                border border-solid border-brand-vibrantPurple
                bg-brand-lilacLight px-[16px] py-[12px]
                ${props.className ?? ""}
            `}
        >
            <img
                className="h-[14px] w-[14px] shrink-0 relative top-[3px]"
                src={infoCircleIcon}
                alt=""
            />

            <PrimaryText typography="textSmall">
                {props.subject} changes take up to{" "}
                <span className="text-bold">60 seconds</span> to apply to new
                checks.
            </PrimaryText>
        </div>
    )
}

interface IPayerMappingsInfoNoticeComponentProps {
    subject: string
    className?: string
}
